<template>
  <div>
    <div>
      <a href="https://www.cms.gov/" class="cms-logo d-block mb-3">
        <span class="cms-logo-acronym">CMS</span>
        <span class="cms-logo-full small">Centers for Medicare &amp; Medicaid Services</span>
      </a>
    </div>
    <div class="social-media-links d-flex">
      <a href="https://www.facebook.com/medicare" class="fb-media-link">Facebook</a>
      <a href="https://x.com/cmsgov" class="x-media-link">X</a>
      <a href="https://www.youtube.com/user/CMSHHSgov" class="yt-media-link">YouTube</a>
      <a href="https://www.linkedin.com/company/centers-for-medicare-&amp;-medicaid-services/"
        class="li-media-link"
      >LinkedIn</a>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.cms-logo {
  color: inherit;
  text-decoration: none;

  .cms-logo-acronym {
    display: block;
    font-size: 3em;
    font-weight: 900;
    letter-spacing: -2px;
    line-height: 1em;
  }
  .cms-logo-full {
    display: block;
    letter-spacing: -1px;
    margin-left: 3px;
    margin-top: -5px;
  }
}

.social-media-links a {
  background-position: 50% 50%;
  background-repeat: no-repeat;
  display: block;
  height: 26px;
  margin-right: 0.75rem;
  opacity: 0.9;
  overflow: hidden;
  width: 26px;
}

.fb-media-link { background-image: url('../../assets/icon-facebook.svg'); }
.x-media-link { background-image: url('../../assets/icon-x.svg'); }
.yt-media-link { background-image: url('../../assets/icon-youtube.svg'); }
.li-media-link { background-image: url('../../assets/icon-linkedin.svg'); }
.ig-media-link { background-image: url('../../assets/icon-instagram.svg'); }

.social-media-links a {
  &:before {
    content: '';
    display: block;
    height: 150%;
    width: 0;
  }
}
</style>
